import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['QuestionsReports'] });

const apiQuestionsReportsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    listQuestionAbuseReports: builder.query({
      query: ({ ean, questionId }) => ({
        url: `/community/products/${ean}/questions/${questionId}/abuse/`,
      }),
      providesTags: (result, error, arg) => [{ type: 'QuestionsReports', id: arg.questionId }],
    }),
    createQuestionAbuseReport: builder.mutation({
      query: ({ ean, questionId, payload }) => ({
        url: `/community/products/${ean}/questions/${questionId}/abuse/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'QuestionsReports', id: arg.questionId }],
    }),
    retrieveQuestionAbuseReport: builder.query({
      query: ({ ean, questionId, id }) => ({
        url: `/community/products/${ean}/questions/${questionId}/abuse/${id}`,
      }),
      providesTags: (result, error, arg) => [{ type: 'QuestionsReports', id: arg.questionId }],
    }),
    partialUpdateQuestionAbuseReport: builder.mutation({
      query: ({ ean, questionId, id, note }) => ({
        url: `/community/products/${ean}/questions/${questionId}/abuse/${id}`,
        method: 'PATCH',
        body: { note },
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'QuestionsReports', id: arg.questionId }],
    }),
    destroyQuestionAbuseReport: builder.mutation({
      query: ({ ean, questionId, id }) => ({
        url: `/community/products/${ean}/questions/${questionId}/abuse/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'QuestionsReports', id: arg.questionId }],
    }),
  }),
});

export const { useListQuestionAbuseReportsQuery, useCreateQuestionAbuseReportMutation, useRetrieveQuestionAbuseReportQuery, usePartialUpdateQuestionAbuseReportMutation, useDestroyQuestionAbuseReportMutation } = apiQuestionsReportsSlice;

export default apiQuestionsReportsSlice;
